import { render, staticRenderFns } from "./bestGoodsFloor.vue?vue&type=template&id=fd1a8120&scoped=true&"
import script from "./bestGoodsFloor.vue?vue&type=script&lang=js&"
export * from "./bestGoodsFloor.vue?vue&type=script&lang=js&"
import style0 from "./bestGoodsFloor.vue?vue&type=style&index=0&id=fd1a8120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd1a8120",
  null
  
)

export default component.exports